import { Bonus, makeFloat } from 'react-easyrocket';

type GetMinDepositOfBonusParams = { bonus: Bonus | undefined; currency: string };

export function getMinDepositOfBonus({ currency, bonus }: GetMinDepositOfBonusParams) {
  return Number(makeFloat(bonus?.minDepositAmount[currency]));
}
